(() => {
  if (window.eleatBundleGuidanceInstalled) return;
  window.eleatBundleGuidanceInstalled = true;
  const controllers = new Map();
  function initialise() {
    document.querySelectorAll('[data-bab-guidance]').forEach(root => {
      if (controllers.has(root)) return;
      const copyElement = document.querySelector('[data-bab-guidance-copy]');
      const contents = root.querySelector('.product-bundle__contents');
      const count = root.querySelector('.build-a-bundle__progress-bar-count-current');
      const sizes = root.querySelector('.build-a-bundle__size-buttons');
      if (!copyElement || !contents || !count || !sizes) return;
      const copy = JSON.parse(copyElement.textContent);
      let frame = 0;
      function syncPurchase() {
        const subscription = ['subscription', 'subscribe'].includes(contents.dataset.purchaseType);
        contents.dataset.straightToCheckout = String(subscription);
        const text = subscription ? copy.checkout : copy.addToCart;
        root.querySelectorAll('.build-a-bundle__add-to-cart-mobile-complete-label').forEach(node => { if (node.textContent !== text) node.textContent = text; });
        return text;
      }
      function beforePurchase(event) {
        if (event.target instanceof Element && event.target.closest('.build-a-bundle__add-to-cart, .build-a-bundle__add-to-cart-mobile')) syncPurchase();
      }
      function sync() {
        frame = 0;
        const purchaseLabel = syncPurchase();
        const max = Number(sizes.querySelector('.active[data-size]')?.dataset.size) || 6;
        const current = Number(count.textContent.trim()) || 0;
        const ready = current === max;
        const excess = Math.max(0, current - max);
        const remaining = Math.max(0, max - current);
        root.dataset.babGuidanceReady = String(ready);
        const label = excess ? (excess === 1 ? copy.removeOne : copy.removeMore.replace('[count]', String(excess))) : remaining === 1 ? copy.addOne : copy.addMore.replace('[count]', String(remaining));
        let notice = root.querySelector('[data-bab-size-notice]');
        if (!notice) {
          notice = document.createElement('p');
          notice.dataset.babSizeNotice = '';
          notice.setAttribute('role', 'status');
          notice.style.cssText = 'font:400 14px/1.4 paralucent,sans-serif;margin:10px 0;color:#241f21;';
          sizes.after(notice);
        }
        const noticeText = excess ? copy.overfilled.replace('[count]', excess).replace('[packs]', excess === 1 ? copy.pack : copy.packs).replace('[size]', max) : '';
        if (notice.textContent !== noticeText) notice.textContent = noticeText;
        notice.hidden = !excess;
        root.querySelectorAll('[data-bab-action-verb]').forEach(node => { node.textContent = excess ? copy.remove : copy.choose; });
        root.querySelectorAll('[data-bab-pack-noun]').forEach(node => { node.textContent = excess ? (excess === 1 ? copy.pack : copy.packs) : (remaining === 1 ? copy.morePack : copy.morePacks); });
        root.querySelectorAll('.build-a-bundle__add-to-cart-mobile-incomplete').forEach(node => { if (node.textContent !== label) node.textContent = label; });
        root.querySelectorAll('.build-a-bundle__add-to-cart-mobile').forEach(button => {
          const disabled = !ready || button.getAttribute('aria-busy') === 'true';
          button.disabled = disabled;
          button.setAttribute('aria-disabled', String(disabled));
          const legacyLabel = button.querySelector('.build-a-bundle__add-to-cart-mobile-label');
          const buttonLabel = ready ? purchaseLabel : label;
          if (legacyLabel && legacyLabel.textContent !== buttonLabel) legacyLabel.textContent = buttonLabel;
        });
        root.querySelectorAll('[data-bab-box-ready]').forEach(node => { node.hidden = !ready; });
      }
      function schedule() { if (!frame) frame = requestAnimationFrame(sync); }
      function onClick(event) {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('.bundle-card__quantity, .build-a-bundle__quick-bundle-add, .build-a-bundle__size-button')) schedule();
      }
      const observer = new MutationObserver(schedule);
      observer.observe(contents, { attributes: true, attributeFilter: ['data-purchase-type'] });
      observer.observe(count, { childList: true, characterData: true, subtree: true });
      observer.observe(sizes, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'data-size'] });
      root.querySelectorAll('.build-a-bundle__add-to-cart-mobile').forEach(button => {
        observer.observe(button, { attributes: true, attributeFilter: ['aria-busy'] });
      });
      root.addEventListener('click', beforePurchase, true);
      root.addEventListener('click', onClick);
      sync();
      controllers.set(root, () => { observer.disconnect(); root.removeEventListener('click', beforePurchase, true); root.removeEventListener('click', onClick); if (frame) cancelAnimationFrame(frame); controllers.delete(root); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('shopify:section:unload', event => { controllers.forEach((destroy, root) => { if (event.target.contains(root)) destroy(); }); });
})();


